// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var padding = BsCssJs$PrezzeeRibbon.px(10);

var flagBlock = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.paddingLeft(padding),
      BsCssJs$PrezzeeRibbon.paddingRight(padding),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
    ]);

var spacing = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(10)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center")
    ]);

var Styles = {
  padding: padding,
  flagBlock: flagBlock,
  spacing: spacing
};

function RegionIndicatorFlag(props) {
  var text = props.text;
  var icon = props.icon;
  var icon$1 = icon !== undefined ? Caml_option.valFromOption(icon) : null;
  var text$1 = text !== undefined ? text : "";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.flag,
                      className: spacing
                    }),
                icon$1,
                text$1
              ],
              className: flagBlock
            });
}

var make = RegionIndicatorFlag;

export {
  Styles ,
  make ,
}
/* padding Not a pure module */
